export const DashboardActionTypes = {
  SET_SELECTED_OPTION : "SET_SELECTED_OPTION",
}